
    import infoList from './infoList.vue'
    import componentTitle from './componentTitle.vue'
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        vinCode: string;
    }

    export default defineComponent({
        name: "BaseInfo",
        setup() {
            let state: State = reactive({
                dataList: [],
                vinCode: ''
            })
            let store = useStore()
            
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {basicItemInfos, vin} = data
                state.dataList = basicItemInfos
                state.vinCode = vin;
                // console.log('vin:', vin);
            })
            return {
                state
            }
        },
        components: {
            infoList,
            componentTitle
        }
    })
